// extracted by mini-css-extract-plugin
module.exports = {"pressListSection":"_Press_pressListSection__Hb2ib","pressListSection__item":"_Press_pressListSection__item__sy9By"};